import Map from 'ol/Map';
import View from 'ol/View';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {Draw, Modify, Snap} from 'ol/interaction';
import {Vector as VectorSource} from 'ol/source';
import {Vector as VectorLayer} from 'ol/layer';
import GeoJSON from 'ol/format/GeoJSON';
import {unByKey} from 'ol/Observable';
import {getArea, getLength} from 'ol/sphere';
import {getCenter} from 'ol/extent';
import {Point, LineString, Polygon} from 'ol/geom';
import {toLonLat} from 'ol/proj';

import { xCore, xCoreHelper } from './core';
import { NSFunctions } from "./utils/functions";
import { Map as Module_Map } from './map';
import { NSGeoJson } from './utils/geojson';
import { NSPageLabels } from './page_labels';
import { NSSearchCoordinatesToolbar } from './search_coordinates_toolbar';

import PinAngleIcon from 'bootstrap-icons/icons/pin-angle.svg?raw'
import SlashIcon from 'bootstrap-icons/icons/slash.svg?raw'
import StopIcon from 'bootstrap-icons/icons/stop.svg?raw'
import CloseIcon from 'bootstrap-icons/icons/x.svg?raw'

export let NSToolDraw = {};

NSToolDraw.init = function()
{
    NSToolDrawPrivate.init();
	
    this.f_disable =                    function () { return NSToolDrawPrivate.f_disable.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_marker_enable = 	    function () { return NSToolDrawPrivate.f_draw_marker_enable.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_marker_disable = 	    function () { return NSToolDrawPrivate.f_draw_marker_disable.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_polyline_enable = 	    function () { return NSToolDrawPrivate.f_draw_polyline_enable.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_polyline_disable = 	    function () { return NSToolDrawPrivate.f_draw_polyline_disable.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_polygon_enable = 	    function () { return NSToolDrawPrivate.f_draw_polygon_enable.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_polygon_disable = 	    function () { return NSToolDrawPrivate.f_draw_polygon_disable.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_tool_is_active = 	    function () { return NSToolDrawPrivate.f_draw_tool_is_active.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_marker_is_active = 	    function () { return NSToolDrawPrivate.f_draw_marker_is_active.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_polyline_is_active = 	function () { return NSToolDrawPrivate.f_draw_polyline_is_active.apply( NSToolDrawPrivate, arguments ); };
	this.f_draw_polygon_is_active = 	function () { return NSToolDrawPrivate.f_draw_polygon_is_active.apply( NSToolDrawPrivate, arguments ); };

	this.f_draw_marker_hide =           function () { return NSToolDrawVisualInterfacePrivate.f_draw_marker_hide.apply( NSToolDrawVisualInterfacePrivate, arguments ); };
	this.f_polyline_hide = 	            function () { return NSToolDrawVisualInterfacePrivate.f_polyline_hide.apply( NSToolDrawVisualInterfacePrivate, arguments ); };
	this.f_draw_polygon_hide =          function () { return NSToolDrawVisualInterfacePrivate.f_draw_polygon_hide.apply( NSToolDrawVisualInterfacePrivate, arguments ); };
   
    //this.f_draw_enable = 	function () { return NSToolDrawPrivate.f_draw_polygon_is_active.apply( NSToolDrawPrivate, arguments ); };


	
	this.f_get_drawn_map_feature = 	                    function () { return NSToolDrawPrivate.f_get_drawn_map_feature.apply( NSToolDrawPrivate, arguments ); };
    this.f_get_drawn_geometry_as_geo_json_feature = 	function () { return NSToolDrawPrivate.f_get_drawn_geometry_as_geo_json_feature.apply( NSToolDrawPrivate, arguments ); };
    this.f_get_drawn_polygon_area_and_perimeter = 	    function () { return NSToolDrawPrivate.f_get_drawn_polygon_area_and_perimeter.apply( NSToolDrawPrivate, arguments ); };
    this.f_get_drawn_polygon_center = 	                function () { return NSToolDrawPrivate.f_get_drawn_polygon_center.apply( NSToolDrawPrivate, arguments ); };
    
    this.f_draw_marker_is_active_and_a_marker_is_drawn =            function () { return NSToolDrawPrivate.f_draw_marker_is_active_and_a_marker_is_drawn.apply( NSToolDrawPrivate, arguments ); };
    this.f_draw_marker_is_active_and_a_marker_is_drawn_or_empty = 	function () { return NSToolDrawPrivate.f_draw_marker_is_active_and_a_marker_is_drawn_or_empty.apply( NSToolDrawPrivate, arguments ); };
    this.f_draw_polyline_is_active_and_a_line_is_drawn = 	        function () { return NSToolDrawPrivate.f_draw_polyline_is_active_and_a_line_is_drawn.apply( NSToolDrawPrivate, arguments ); };
    this.f_draw_polyline_is_active_and_a_line_is_drawn_or_empty = 	function () { return NSToolDrawPrivate.f_draw_polyline_is_active_and_a_line_is_drawn_or_empty.apply( NSToolDrawPrivate, arguments ); };
    this.f_draw_polygon_is_active_and_an_area_is_drawn = 	        function () { return NSToolDrawPrivate.f_draw_polygon_is_active_and_an_area_is_drawn.apply( NSToolDrawPrivate, arguments ); };
    this.f_draw_polygon_is_active_and_an_area_is_drawn_or_empty = 	function () { return NSToolDrawPrivate.f_draw_polygon_is_active_and_an_area_is_drawn_or_empty.apply( NSToolDrawPrivate, arguments ); };
    this.f_ensure_draw_polygon_is_active = 	                        function () { return NSToolDrawPrivate.f_ensure_draw_polygon_is_active.apply( NSToolDrawPrivate, arguments ); };
    
    this.f_set_as_draft = 	                            function () { return NSToolDrawPrivate.f_set_as_draft.apply( NSToolDrawPrivate, arguments ); };

    
    


    NSToolDrawVisualInterfacePrivate.init();
	
	
	window.NSToolDraw_ = NSToolDraw;
	window.NSToolDrawPrivate_ = NSToolDrawPrivate;

    /*
        f_draw_marker_enable
        f_draw_marker_disable
        f_draw_polyline_enable
        f_draw_polyline_disable
        f_draw_polygon_enable
        f_draw_polygon_disable
        f_draw_tool_is_active
        f_draw_marker_is_active
        f_draw_polyline_is_active
        f_draw_polygon_is_active
        f_draw_marker_is_active_and_a_marker_is_drawn
        f_draw_marker_is_active_and_a_marker_is_drawn_or_empty
        f_draw_polyline_is_active_and_a_line_is_drawn
        f_draw_polyline_is_active_and_a_line_is_drawn_or_empty
        f_draw_polygon_is_active_and_an_area_is_drawn
        f_draw_polygon_is_active_and_an_area_is_drawn_or_empty
        f_get_marker_position
        f_get_marker_position_a_x_y
        f_get_polyline_a_x_y_path
        f_get_polyline_geojson_a_coordinates
        f_get_polygon_path_long_lat
        f_get_polygon_a_x_y_path
        f_get_polygon_geojson_a_coordinates
        f_get_marker_xy_position____update_format
        f_get_polyline_x_y____update_format
        f_get_polygon_x_y____update_format
        drawMarker
        drawPolyline
        drawPolylineOrPolygon_from_geoJsonFeatureGeometry
        drawEditableTrailFromGeoJson
        drawPolygon
        ---------------
        f_refresh_measurements

     */
	
}


let NSToolDrawPrivate = {
	
	private_objs:
	{
		/*
        draw        -> depende do tipo, point line polygon...
        modify
        snap
        */

        map: null,
        vector_source: null,
        vector_layer: null,
        style: null,
        style_draft: null,
        style_draw: null,
        style_modify: null,

        draw: null,
        modify: null,
        snap: null,

        o_geom_onchange_listener: null,

        b_draw_point_is_active: null,
        b_draw_polyline_is_active: null,
        b_draw_polygon_is_active: null,

        
        
		
	},
	
	

	init: function()
	{
	
        this.private_objs.map = Module_Map.f_get_map();
        
        this.private_objs.b_draw_point_is_active = false;
        this.private_objs.b_draw_polyline_is_active = false;
        this.private_objs.b_draw_polygon_is_active = false;


        this.private_objs.style =  new Style({
            fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
            }),
            stroke: new Stroke({
            color: '#ff0000',
            width: 3,
            }),
            image: new CircleStyle({
            radius: 12,
            fill: new Fill({
                color: '#ff0000',
            }),
            }),
        });

        this.private_objs.style_draft =  new Style({
            fill: new Fill({
            color: [200,0,0,0.2],   // [R,G,B,A]
            }),
            stroke: new Stroke({
            color: [200,0,0,0.5],   // [R,G,B,A]
            width: 3,
            }),
            image: new CircleStyle({
            radius: 12,
            fill: new Fill({
                color: [200,0,0,0.5],   // [R,G,B,A]
            }),
            }),
        });

        this.private_objs.style_draw = new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)',
            }),
            stroke: new Stroke({
              color: 'rgba(0, 0, 0, 0.5)',
              lineDash: [10, 10],
              width: 3,
            }),
            image: new CircleStyle({
              radius: 5,
              stroke: new Stroke({
                color: 'rgba(0, 0, 0, 0.7)',
                //lineDash: [10, 10],
                width: 3
              }),
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.92)',
              }),
            })
          });

          this.private_objs.style_modify = new Style({
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                  color: 'rgba(0, 0, 0, 0.7)',
                  //lineDash: [10, 10],
                  width: 3
                }),
                fill: new Fill({
                  color: 'rgba(255, 255, 255, 0.92)',
                }),
              })
          });

        this.private_objs.vector_source = new VectorSource();
        this.private_objs.vector_layer = new VectorLayer({
            source: this.private_objs.vector_source,
            style: this.private_objs.style,
            zIndex: 100     // So it will overlap any layers enabled after the drawing tool
        });

        
		
        this.o_measures_info.init();
	},

    /* o_geo_json_feature -> optional */
    f_draw_marker_enable: function(o_geojson_feature_geometry)
    {
        /*
            o_in: { b_point, b_polyline, b_polygon }
        */
        this.f_draw_geom_({b_point: true, o_geojson_feature_geometry: o_geojson_feature_geometry});
    },
    f_draw_marker_disable: function()
    {

    },

    /* o_geo_json_feature -> optional */
    f_draw_polyline_enable: function(o_geojson_feature_geometry)
    {
        /*
            o_in: { b_point, b_polyline, b_polygon }
        */
        this.f_draw_geom_({b_polyline: true, o_geojson_feature_geometry: o_geojson_feature_geometry});
    },
    f_draw_polyline_disable: function()
    {

    },

    
    /* o_geo_json_feature -> optional */
    f_draw_polygon_enable: function(o_geojson_feature_geometry)
    {
        /*
            o_in: { b_point, b_polyline, b_polygon, o_geojson_feature_geometry }
        */
        this.f_draw_geom_({b_polygon: true, o_geojson_feature_geometry: o_geojson_feature_geometry});
    },
    f_draw_polygon_disable: function()
    {

    },
    f_draw_tool_is_active: function()
    { 
        return this.f_draw_marker_is_active() || this.f_draw_polyline_is_active() || this.f_draw_polygon_is_active();
    },
    f_draw_marker_is_active: function()
    {
        return this.private_objs.b_draw_point_is_active;
    },
    f_draw_polyline_is_active: function()
    {
        return this.private_objs.b_draw_polyline_is_active;
    },
    f_draw_polygon_is_active: function()
    {
        return this.private_objs.b_draw_polygon_is_active;
    },

    /*
        o_in:
        {
            b_point,
            b_polyline,
            b_polygon,

            o_geojson_feature_geometry
        }
    */
    f_draw_geom_: function(o_in)
    {
        let this_ = this;
        let private_objs = this.private_objs;

        let o_geojson_feature_geometry = o_in.o_geojson_feature_geometry;

        this.f_disable();

        let s_type;
        if(o_in.b_point)
        {
            s_type = "Point";
        }
        else if(o_in.b_polyline)
        {
            s_type = "LineString";
        }
        else// if(o_in.b_polygon)
        {
            s_type = "Polygon";            
        }

        let map = this.private_objs.map;
        let vector_source = this.private_objs.vector_source;
        let vector_layer = this.private_objs.vector_layer;
        map.addLayer(vector_layer);
        let modify = new Modify({source: vector_source, style: private_objs.style_modify});
        let draw = new Draw({
            source: vector_source,
            type: s_type,

            style: private_objs.style_draw
        });
        let snap = new Snap({source: vector_source});
    
        this.private_objs.modify =  modify;
        this.private_objs.draw =  draw;
        this.private_objs.snap =  snap;
        
        map.addInteraction(modify);
        map.addInteraction(draw);
        map.addInteraction(snap);

        let f_process_geom_onstart_onchange = function (geom)
        {
            let b_marker, b_polyline, b_polygon, s_position_lat, s_position_lng, s_length, s_area;
            if (geom instanceof Point) {
                //console.log("geom instanceof Point !!!!!!!!!!!!!!!!!!!!!!!");
                b_marker = true;
                let o_ll_wgs84 = toLonLat( geom.getCoordinates() );
                //console.log("o_ll_wgs84:"); console.log(o_ll_wgs84);
                let i_dp = 4;
                s_position_lat = NSFunctions.roundNumber(o_ll_wgs84[1], i_dp) + "";
                s_position_lng = NSFunctions.roundNumber(o_ll_wgs84[0], i_dp) + "";
            }
            else if (geom instanceof LineString) {
                b_polyline = true;
                let n_length = getLength(geom);
                let i_dp = 2;
                s_length = NSFunctions.roundNumber(n_length, i_dp) + "";
                //tooltipCoord = geom.getLastCoordinate();
            }
            else if (geom instanceof Polygon) {
                b_polygon = true;
                
                //console.log("geom instanceof Polygon !!!!!!!!!!!!!!!!!!!!!!!");
                let a_coords_wgs84 = [];
                geom.getCoordinates()[0].forEach(a_point => {
                    a_coords_wgs84.push(toLonLat(a_point));
                });
                //console.log("a_coords_wgs84:"); console.log(a_coords_wgs84);
                let n_length = getLength(geom);
                let n_area = getArea(geom);
                let  i_dp = 2;
                s_length = NSFunctions.roundNumber(n_length, i_dp) + "";
                s_area = NSFunctions.roundNumber(n_area, i_dp) + "";
                //tooltipCoord = geom.getInteriorPoint().getCoordinates();
            } 
            //measureTooltipElement.innerHTML = output;
            //measureTooltip.setPosition(tooltipCoord);

            let o_in ={
                b_marker: b_marker,
                b_polyline: b_polyline,
                b_polygon: b_polygon,
                
                s_position_lat: s_position_lat,	// (º)
                s_position_lng: s_position_lng, // (º)
                s_length: s_length,				// (m)
                s_area: s_area,					// (m)
            }
            
            this_.o_measures_info.f_refresh_content(o_in);
        };

        if(o_geojson_feature_geometry != null)
        {
            let o_geojson_feature = NSGeoJson.f_get_geojson_feature_from_geojson_geometry(o_geojson_feature_geometry)
            let o_ol_feature = new GeoJSON().readFeature(o_geojson_feature);
            vector_source.addFeature(o_ol_feature);
            
            f_process_geom_onstart_onchange(o_ol_feature.getGeometry());
        }

        draw.on('drawstart', function (o_evt_drawstart) {
            //console.log('ESTOU AQUIIIIIIIIIII!!!!!!!!!!!!!');
            //console.log(o_evt_drawstart);
            //console.log(private_objs.vector_source.getFeatures());
            this_.f_clear_geometries();
            //console.log(private_objs.vector_source.getFeatures());
            //---------------------------------------------------------------------
            //setup measures:
            let geom_ondrawstart = o_evt_drawstart.feature.getGeometry();
            f_process_geom_onstart_onchange(geom_ondrawstart);

            // set sketch
            let sketch = o_evt_drawstart.feature;

            /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
            //let tooltipCoord = evt.coordinate;

            if(private_objs.o_geom_onchange_listener != null)
            {
                unByKey(private_objs.o_geom_onchange_listener);
            }
            private_objs.o_geom_onchange_listener = sketch.getGeometry().on('change', function (o_evt_change) {
                const geom_onchange = o_evt_change.target;
                f_process_geom_onstart_onchange(geom_onchange);
            });


        });

        this.f_set_state_and_interface_(o_in);

        // Only shows measure info when page is in Normal Mode
        if( !xCoreHelper.f_page_is_in_mini_client_mode() )
        {
            this.o_measures_info.f_show();

            if (s_type === 'Point') this.o_measures_info.f_show_coordinates_search();
            else this.o_measures_info.f_hide_coordinates_search();
        }
    },

    /*
    o_in: { b_point, b_polyline, b_polygon }
    */
    f_set_state_and_interface_: function(o_in)
    {
        let private_objs = this.private_objs;
        /*
        b_draw_point_is_active
        b_draw_polyline_is_active
        b_draw_polygon_is_active
        */
        private_objs.b_draw_point_is_active = o_in.b_point ? true : false;
        private_objs.b_draw_polyline_is_active = o_in.b_polyline ? true : false;
        private_objs.b_draw_polygon_is_active = o_in.b_polygon ? true : false;

        NSToolDrawVisualInterfacePrivate.f_refresh_interface();

    },

    f_disable: function()
    {
        this.f_disable_();
        this.f_set_state_and_interface_({});

        this.o_measures_info.f_hide();
        this.o_measures_info.f_hide_coordinates_search();
    },

    f_disable_: function()
    {
        let map = this.private_objs.map;

        map.removeInteraction(this.private_objs.modify);
        map.removeInteraction(this.private_objs.draw);
        map.removeInteraction(this.private_objs.snap);
        map.removeLayer(this.private_objs.vector_layer);
        
        this.private_objs.modify = null;
        this.private_objs.draw = null;
        this.private_objs.snap = null;

        this.f_clear_geometries();

        
    },

    f_clear_geometries: function()
    {
        this.private_objs.vector_source.clear();    //removes all features
    },

    f_get_drawn_map_feature: function()
    {
        let a_map_feature = NSToolDrawPrivate_.private_objs.vector_source.getFeatures();
        let o_map_feature = (a_map_feature.length > 0) ? a_map_feature[0]: null;

        return o_map_feature;


    },

    f_get_drawn_geometry_as_geo_json_feature: function()
    {
        let a_map_feature = NSToolDrawPrivate_.private_objs.vector_source.getFeatures();
        let o_map_feature = (a_map_feature.length > 0) ? a_map_feature[0]: null;

        let o_gj = ( o_map_feature != null ) ? new GeoJSON().writeFeatureObject(o_map_feature, {rightHanded: true}) : null;

        return o_gj;
        
    },

    f_get_drawn_polygon_area_and_perimeter: function(i_decimal_places)
    {
        let b_draw_polygon_is_active_and_an_area_is_drawn = this.f_draw_polygon_is_active_and_an_area_is_drawn();
        if (b_draw_polygon_is_active_and_an_area_is_drawn)
        {
            let i_dp = ( i_decimal_places!=null )? i_decimal_places : 10;
            let o_map_feature = this.f_get_drawn_map_feature();
            let geom = o_map_feature.getGeometry();
            let n_length = getLength(geom);
            let n_area = getArea(geom);
            
            let s_length = NSFunctions.roundNumber(n_length, i_dp) + "";
            let s_area = NSFunctions.roundNumber(n_area, i_dp) + "";

            return {
                area: s_area,
                length: s_length
            };
            
        }
    },

    f_get_drawn_polygon_center: function(i_decimal_places)
    {
        let b_draw_polygon_is_active_and_an_area_is_drawn = this.f_draw_polygon_is_active_and_an_area_is_drawn();
        if (b_draw_polygon_is_active_and_an_area_is_drawn)
        {
            let i_dp = ( i_decimal_places!=null )? i_decimal_places : 10;
            let o_map_feature = this.f_get_drawn_map_feature();
            let geom = o_map_feature.getGeometry();
            let extent = geom.getExtent();
            let a_xy = getCenter(extent);

            return a_xy;
            
        }
    },

    //----------------------------------------------------------------------
    f_draw_marker_is_active_and_a_marker_is_drawn: function()
	{
		var b_res = this.f_draw_marker_is_active();
        if(b_res== true)
		{
            let o_gj_f = this.f_get_drawn_geometry_as_geo_json_feature();
			b_res = (o_gj_f != null)? true : false;
		}
			
		return b_res;
	},
    f_draw_marker_is_active_and_a_marker_is_drawn_or_empty: function()
	{
		var b_res = this.f_draw_marker_is_active();
			
		return b_res;
	},
	
	f_draw_polyline_is_active_and_a_line_is_drawn: function()
	{
		var b_res = this.f_draw_polyline_is_active();
		if(b_res== true)
		{
            let o_gj_f = this.f_get_drawn_geometry_as_geo_json_feature();
			b_res = (o_gj_f != null)? true : false;
		}
			
		return b_res;
	},
	f_draw_polyline_is_active_and_a_line_is_drawn_or_empty: function()
	{
		var b_res = this.f_draw_polyline_is_active();
		if(b_res== true)
		{
            //let o_gj_f = this.f_get_drawn_geometry_as_geo_json_feature();
			
		}
			
		return b_res;
	},
	f_draw_polygon_is_active_and_an_area_is_drawn: function()
	{
		var b_res = this.f_draw_polygon_is_active();
		if(b_res== true)
		{
            let o_gj_f = this.f_get_drawn_geometry_as_geo_json_feature();
			b_res = (o_gj_f != null)? true : false;
		}
			
		return b_res;
	},
	f_draw_polygon_is_active_and_an_area_is_drawn_or_empty: function()
	{
		var b_res = this.f_draw_polygon_is_active();
		if(b_res== true)
		{
            //let o_gj_f = this.f_get_drawn_geometry_as_geo_json_feature();
		}
			
		return b_res;
	},
	f_ensure_draw_polygon_is_active: function()
	{
		var b_res = this.f_draw_polygon_is_active();
		if(!b_res)
		{
            this.f_draw_polygon_enable();
		}
	},


    //------------------------------------------------------------------------

    f_set_as_draft: function()
    {

        let a_fs = NSToolDrawPrivate_.private_objs.vector_source.getFeatures();
        if ( a_fs != null && a_fs.length>0)
        {
    
            let o_f = a_fs[0];
            /*
            o_f.setStyle(    
                new Style({
                    stroke: new Stroke({
                        color: [255,255,255,0.5],   // [R,G,B,A]
                        width: 2})
                })
            );
            */
            o_f.setStyle( this.private_objs.style_draft );

        }

    },
        
    
    
        
    o_measures_info: {
		private_objs: 
		{
			e_measures_info: null,
			
			e_div_measures_position: null,
			e_div_measures_length: null,
			e_div_measures_area: null,
			
			e_span_position_lat: null,
			e_span_position_lng: null,
			e_span_length: null,
			e_span_area: null
		},
		
		init: function()
		{
			this.f_create_page_html();
		},
		
		f_create_page_html: function()
		{
			var this_ = this;
			
			var private_objs = this.private_objs;
			
			var s_html = `
			<div id="measures-info">
                <div class="inner-container">
                    <div id="div_measures_position">
                        <span id="span_position_lat"></span>
                        <br>
                        <span id="span_position_lng"></span>
                    </div>
                    <div id="div_measures_length">
                        <span id="span_length"></span>
                    </div>
                    <div id="div_measures_area">
                        <span id="span_area"></span>
                    </div>
                </div>
            </div>
			`;

			var e_body = document.getElementsByTagName("body")[0];
			NSFunctions.f_dom_elem_append_dom_childs_by_html(e_body, s_html);
			
			private_objs.e_measures_info = document.getElementById("measures-info");
			
			private_objs.e_div_measures_position = document.getElementById("div_measures_position");
			private_objs.e_div_measures_length = document.getElementById("div_measures_length");
			private_objs.e_div_measures_area = document.getElementById("div_measures_area");
			
			private_objs.e_span_position_lat = document.getElementById("span_position_lat");
			private_objs.e_span_position_lng = document.getElementById("span_position_lng");
			private_objs.e_span_length = document.getElementById("span_length");
			private_objs.e_span_area = document.getElementById("span_area");
			
			this.f_hide();
			
		},
		
		f_show: function()
		{
			var e_div = this.private_objs.e_measures_info;
			this.f_show_div_(e_div);
		},
		f_hide: function()
		{
			this.f_clean_content();
			var e_div = this.private_objs.e_measures_info;
			this.f_hide_div_(e_div);
		},
        f_show_coordinates_search: function() {
            NSSearchCoordinatesToolbar.f_open();
        },
        f_hide_coordinates_search: function() {
            NSSearchCoordinatesToolbar.f_close();
        },
		f_show_div_position: function()
		{
			var e_div = this.private_objs.e_div_measures_position;
			this.f_show_div_(e_div);
		},
		f_hide_div_position: function()
		{
			var e_div = this.private_objs.e_div_measures_position;
			this.f_hide_div_(e_div);
		},
		f_show_div_length: function()
		{
			var e_div = this.private_objs.e_div_measures_length;
			this.f_show_div_(e_div);
		},
		f_hide_div_length: function()
		{
			var e_div = this.private_objs.e_div_measures_length;
			this.f_hide_div_(e_div);
		},
		f_show_div_area: function()
		{
			var e_div = this.private_objs.e_div_measures_area;
			this.f_show_div_(e_div);
		},
		f_hide_div_area: function()
		{
			var e_div = this.private_objs.e_div_measures_area;
			this.f_hide_div_(e_div);
		},
		f_show_div_: function(e_div)
		{
			e_div.classList.remove("d-none");
		},
		f_hide_div_: function(e_div)
		{
			e_div.classList.add("d-none");
		},
		
		/*
		o_in : {
			b_marker: b_marker,
			b_polyline: b_polyline,
			b_polygon: b_polygon,
			
			s_position_lat: s_position_lat,	// (º)
			s_position_lng: s_position_lng, // (º)
			s_length: s_length,				// (m)
			s_area: s_area,					// (m)
		}
		*/
		f_refresh_content: function(o_in)
		{
			var private_objs = this.private_objs;
			var e_span_position_lat = private_objs.e_span_position_lat;
			var e_span_position_lng = private_objs.e_span_position_lng;
			var e_span_length = private_objs.e_span_length;
			var e_span_area = private_objs.e_span_area;
			
			
			var b_marker = o_in.b_marker;
			var b_polyline = o_in.b_polyline;
			var b_polygon = o_in.b_polygon;
			
			var s_position_lat = o_in.s_position_lat;	// (º)
			var s_position_lng = o_in.s_position_lng; // (º)
			var s_length = o_in.s_length;				// (m)
			var s_area = o_in.s_area;					// (m)
			
			
			this.f_clean_content();
			var o_show_hide_all_content_divs_in =
			{
				b_marker: o_in.b_marker,
				b_polyline: o_in.b_polyline,
				b_polygon: o_in.b_polygon
			}
			this.f_show_hide_all_content_divs(o_show_hide_all_content_divs_in);
			
			
			var b_position = (b_marker)? true : false;
			var b_length = (b_polyline || b_polygon)? true : false;
			var b_area = (b_polygon)? true : false;
			
			if(b_position)
			{
				e_span_position_lat.innerHTML = "Lat: " + s_position_lat + "º";
				e_span_position_lng.innerHTML = "Lng: " + s_position_lng + "º";
			}
			else
			{
				// b_length
				e_span_length.innerHTML = s_length + " m";
				
				if(b_area)
				{
					e_span_area.innerHTML = s_area + " m&sup2;";
				}
			}
			
			
			
		},
		
		f_clean_content: function()
		{
			var private_objs = this.private_objs;
			var e_span_position_lat = private_objs.e_span_position_lat;
			var e_span_position_lng = private_objs.e_span_position_lng;
			var e_span_length = private_objs.e_span_length;
			var e_span_area = private_objs.e_span_area;
			
			e_span_position_lat.innerHTML = "";
			e_span_position_lng.innerHTML = "";
			e_span_length.innerHTML = "";
			e_span_area.innerHTML = "";
			
		},
		/*
		o_in : {
			b_marker: b_marker,
			b_polyline: b_polyline,
			b_polygon: b_polygon
		}
		*/
		f_show_hide_all_content_divs: function(o_in)
		{
			var b_marker = o_in.b_marker;
			var b_polyline = o_in.b_polyline;
			var b_polygon = o_in.b_polygon;
			
			
			this.f_hide_div_position();
			this.f_hide_div_length();
			this.f_hide_div_area();
			
			if(b_marker)
			{
				this.f_show_div_position();
				this.f_hide_div_length();
				this.f_hide_div_area();
			}
			else
			{
				// b_polyline || b_polygon
				this.f_hide_div_position();
				this.f_show_div_length();
				
				if(b_polygon)
				{
					this.f_show_div_area();
				}
				else
				{
					this.f_hide_div_area();
				}
			}
			
		}
		
	}    
        
        
        
        
        

};


let NSToolDrawVisualInterfacePrivate = {

    private_objs:
    {
        e_div_tooldraw_holder: null,
     
        e_button_tooldraw_draw_marker: null,
        e_button_tooldraw_draw_line: null,
        e_button_tooldraw_draw_polygon: null,
        e_button_tooldraw_clear: null,
    },

    init: function()
    {
		var private_objs = this.private_objs;
        if( !xCoreHelper.f_page_is_in_mini_client_mode() )
        {
            private_objs.e_div_tooldraw_holder = document.getElementById("header-main-buttons");
        }
        else // Page is in Mini Client Mode
        {
            private_objs.e_div_tooldraw_holder = document.getElementById("mini-client-edit-toolbar");            
        }

        this.f_create();

    },
    
    f_draw_marker_hide: function()
    {
        this.private_objs.e_button_tooldraw_draw_marker.classList.add('d-none');
    },
    f_polyline_hide: function()
    {
        this.private_objs.e_button_tooldraw_draw_line.classList.add('d-none');
    },
    f_draw_polygon_hide: function()
    {
        this.private_objs.e_button_tooldraw_draw_polygon.classList.add('d-none');
    },

    f_create: function()
	{
		var private_objs = this.private_objs;
		
		var s_title_button_button_tooldraw_draw_marker =    NSPageLabels.f_get_label_text_by_internal_name("tooldraw_button_point_tooltip");
		var s_title_button_button_tooldraw_draw_line =      NSPageLabels.f_get_label_text_by_internal_name("tooldraw_button_line_tooltip");
		var s_title_button_button_tooldraw_draw_polygon =   NSPageLabels.f_get_label_text_by_internal_name("tooldraw_button_area_tooltip");
		var s_title_button_button_tooldraw_clear =          NSPageLabels.f_get_label_text_by_internal_name("tooldraw_button_clean_tooltip");
		
        var s_button_class = !xCoreHelper.f_page_is_in_mini_client_mode() ? 'btn-outline-secondary' : 'btn-light';
        var s_html = `
            <button id="button_tooldraw_draw_marker" type="button" class="btn ${s_button_class}" title="${s_title_button_button_tooldraw_draw_marker}">${PinAngleIcon}</button>
            <button id="button_tooldraw_draw_line" type="button" class="btn ${s_button_class}" title="${s_title_button_button_tooldraw_draw_line}">${SlashIcon}</button>
            <button id="button_tooldraw_draw_polygon" type="button" class="btn ${s_button_class}" title="${s_title_button_button_tooldraw_draw_polygon}">${StopIcon}</button>
            <button id="button_tooldraw_clear" type="button" class="btn ${s_button_class}" title="${s_title_button_button_tooldraw_clear}">${CloseIcon}</button>
        `;
        
		var e_div_tooldraw_holder = private_objs.e_div_tooldraw_holder;
		e_div_tooldraw_holder.innerHTML = "";
		
		NSFunctions.f_dom_elem_append_dom_childs_by_html(e_div_tooldraw_holder, s_html);
		

		//draw		
		private_objs.e_button_tooldraw_draw_marker = document.getElementById("button_tooldraw_draw_marker");
		private_objs.e_button_tooldraw_draw_line = document.getElementById("button_tooldraw_draw_line");
		private_objs.e_button_tooldraw_draw_polygon = document.getElementById("button_tooldraw_draw_polygon");
		private_objs.e_button_tooldraw_clear = document.getElementById("button_tooldraw_clear");

			
		//this.f_set_header_toolbar_visibility();
		
		this.f_set_buttons_behaviour();
		
	},
    f_set_buttons_behaviour: function()
	{
		var this_ = this;
		var private_objs = this.private_objs;
		
	
		//draw 
		private_objs.e_button_tooldraw_draw_marker.onclick = function(){this_.f_draw_marker_onclick_();};
		private_objs.e_button_tooldraw_draw_line.onclick = function(){this_.f_draw_line_onclick_();};
		private_objs.e_button_tooldraw_draw_polygon.onclick = function(){this_.f_draw_polygon_onclick_();};
		private_objs.e_button_tooldraw_clear.onclick = function(){this_.f_clear_onclick_();};
		
		
		//tool map info
		//var o_info = private_objs.o_info;
		//o_info.e_button_tool_info.onclick = function(){this_.f_tool_info_onclick();};


	},
    f_draw_marker_onclick_: function()
    {
        if(NSToolDrawPrivate.f_draw_marker_is_active())
        {
            NSToolDrawPrivate.f_disable();
        }
        else
        {
            NSToolDrawPrivate.f_draw_marker_enable();
        }
    },
    f_draw_line_onclick_: function()
    {
        
        if(NSToolDrawPrivate.f_draw_polyline_is_active())
        {
            NSToolDrawPrivate.f_disable();
        }
        else
        {
            NSToolDrawPrivate.f_draw_polyline_enable();
        }
    },
    f_draw_polygon_onclick_: function()
    {
        
        if(NSToolDrawPrivate.f_draw_polygon_is_active())
        {
            NSToolDrawPrivate.f_disable();
        }
        else
        {
            NSToolDrawPrivate.f_draw_polygon_enable();
        }
    },
    f_clear_onclick_: function()
    {
        NSToolDrawPrivate.f_disable();;
    },

    f_refresh_interface: function()
    {
        
		var private_objs = this.private_objs;

        let b_draw_point_is_active = NSToolDrawPrivate.f_draw_marker_is_active();
        let b_draw_polyline_is_active = NSToolDrawPrivate.f_draw_polyline_is_active();
        let b_draw_polygon_is_active = NSToolDrawPrivate.f_draw_polygon_is_active();

        let e_button;
        if(b_draw_point_is_active)
        {
            e_button = private_objs.e_button_tooldraw_draw_marker;
        }
        else if(b_draw_polyline_is_active)
        {
            e_button = private_objs.e_button_tooldraw_draw_line;
        }
        else if (b_draw_polygon_is_active)
        {
            e_button = private_objs.e_button_tooldraw_draw_polygon;
        }

        if(e_button != null)
        {
            this.f_highlight_button_(e_button);
        }
        else
        {
            this.f_remove_all_buttons_highlight_();
        }



    },

    f_highlight_button_: function(e_button)
    {
        this.f_remove_all_buttons_highlight_();
       
        e_button.classList.add('active');

    },
    f_remove_all_buttons_highlight_: function()
    {
        let private_objs = this.private_objs;

        let a_e_button = [];
        a_e_button.push(private_objs.e_button_tooldraw_draw_marker);
        a_e_button.push(private_objs.e_button_tooldraw_draw_line);
        a_e_button.push(private_objs.e_button_tooldraw_draw_polygon);

        a_e_button.forEach(e_button_i => {
            this.f_remove_button_highlight_(e_button_i);
        });

    },
    f_remove_button_highlight_: function(e_button)
    {
        e_button.classList.remove('active');
    }

}